<script lang="ts">
	import MoreIcon from 'assets/svg/more.svg?component';
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import Learn from 'assets/svg/learn.svg?component';
	import News from 'assets/svg/news.svg?component';
	import Glossary from 'assets/svg/glossary.svg?component';
	import activeLocale from 'stores/activeLocale';
	import { _ } from 'utils/i18/i18n';
	import { onMount } from 'svelte';

	$: normalizedLocale = $activeLocale.locale === 'en' ? '' : `/${$activeLocale.locale}/`;

	let isOpen = false;
	let selectRef: HTMLDivElement;

	onMount(() => {
		document.addEventListener('click', handleClose);

		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (selectRef && !selectRef.contains(e.target)) {
			isOpen = false;
		}
	};
</script>

<div class="dropdown">
	<div
		bind:this={selectRef}
		class="wrapper"
		on:click={() => {
			isOpen = !isOpen;
		}}
	>
		<div class="text-wrapper">
			<MoreIcon width={14} height={12} class="more-icon" />
			<div class="text">More</div>
		</div>
		{#if isOpen}
			<ArrowUp class="toggle-icon" width={8} height={8} />
		{:else}
			<ArrowDown class="toggle-icon" width={8} height={8} />
		{/if}
	</div>
	<ul class="link-list" class:visible={isOpen}>
		<li
			on:click={async () => {
				isOpen = !isOpen;
			}}
		>
			<a href={`/learn${normalizedLocale}`} class="option-link">
				<Learn width={14} height={14} class="link-icon" />
				<p class="link-title">{$_('navigation.learn')}</p>
			</a>
		</li>
		<li
			on:click={async () => {
				isOpen = !isOpen;
			}}
		>
			<a href={`/news${normalizedLocale}`} class="option-link">
				<News width={14} height={14} class="link-icon" />
				<p class="link-title">{$_('navigation.news')}</p>
			</a>
		</li>
		<li
			on:click={async () => {
				isOpen = !isOpen;
			}}
		>
			<a href={`/learn/glossary${normalizedLocale}`} class="option-link">
				<Glossary width={14} height={14} class="link-icon" />
				<p class="link-title">{$_('navigation.glossary')}</p>
			</a>
		</li>
	</ul>
</div>

<style lang="scss">
	@import 'morePagesDropdown';
</style>
